<div [formGroup]="form" class="relative w-full flex flex-row gap-x-2">
  <mat-form-field class="w-1/2">
    <mat-label>{{ currencyLabel }}</mat-label>
    <mat-select
      [attr.name]="inputName"
      placeholder="Currency"
      formControlName="selectedCurrency"
      (selectionChange)="onCurrencyChange($event)"
    >
      @for (currency of currencyList; track currency) {
        <mat-option [value]="currency">
          {{ currency | spaces }}
        </mat-option>
      }
    </mat-select>
    @if (form.controls.selectedCurrency.value && form.enabled) {
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="resetCurrency()"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <phoenix-unit-nanos-control
    class="w-1/2"
    [label]="label"
    [unit]="units"
    [nanos]="nanos"
  >
  </phoenix-unit-nanos-control>

  @if (helperText) {
    <div
      class="absolute left-full top-3 w-12 -translate-x-3 flex justify-center ml-2"
    >
      <phoenix-info-helper [tooltip]="helperText"></phoenix-info-helper>
    </div>
  }
</div>
